import * as THREE from 'three'
import Experience from '../Experience'

import gsap from 'gsap'

let planeGeometry = new THREE.PlaneGeometry(1, 1)

export default class Card extends THREE.Object3D {
  constructor(texture) {
    super()

    this.experience = new Experience
    this.items = this.experience.resources.items
    this.texture = texture

    this.createBack()
    this.createFront()

    let x = 5.12
    let y = 6.16
    let scl = 0.14
    this.scale.set(x * scl, y * scl, 1)

    this.up = new THREE.Vector3(0, 1, 0)
  }

  createBack() {
    let alphaMap = this.items.cardAlphaMap

    this.backMaterial = new THREE.MeshBasicMaterial({
      color: '#EEEEEE',
      alphaMap,
      transparent: true,
      opacity: 0.95,
      side: THREE.DoubleSide,
      // depthTest: false,
      // depthWrite: false,
    })

    this.backMesh = new THREE.Mesh(planeGeometry, this.backMaterial)

    this.add(this.backMesh)
  }

  createFront() {
    this.frontMaterial = new THREE.MeshBasicMaterial({
      map: this.texture,
      transparent: true,
      side: THREE.DoubleSide,
      // depthTest: false,
      // depthWrite: false,      
    })

    this.frontMesh = new THREE.Mesh(planeGeometry, this.frontMaterial)

    this.add(this.frontMesh)
  }

  setOpacity() {
    this.backMaterial.opacity = 0.95
    this.frontMaterial.opacity = 1
  }

  animateOut() {
    let materials = [this.backMaterial, this.frontMaterial]

    const tl = gsap.timeline()

    tl
      .to(materials, {
        duration: 1,
        ease: 'expo',
        opacity: 0,
      })

    return tl
  }

  scrubOut() {
    let materials = [this.backMaterial, this.frontMaterial]

    const tl = gsap.timeline()

    tl
      .to(materials, {
        ease: 'linear',
        opacity: 0,
      })

    return tl
  }
}